module.exports = __webpack_public_path__ + "cb39a90bf13d094c28b886ba9f0e6c9b.jpeg";